import styled from "styled-components";
import colors from "../common/colors";
import { fontSize, space } from "../common/variables";

export const ORDERER_ADMIN_NO_UNITS_MESSAGE =
    "Du har inga enheter tilldelade. Du kan inte se slutkunder, beställare eller enheter förrän en administratör tilldelar enheter.";

const OrdererAdminNoUnitsBanner = () => (
    <Banner role="status">{ORDERER_ADMIN_NO_UNITS_MESSAGE}</Banner>
);

export default OrdererAdminNoUnitsBanner;

const Banner = styled.div`
    width: 100%;
    padding: ${space.small} ${space.medium};
    text-align: center;
    font-size: ${fontSize.small};
    font-weight: 600;
    color: ${colors.black};
    background-color: ${colors.greenLight};
`;
